import React from 'react'

import IconButton from '../../packages/kiti/components/actions/IconButton'

const _IconButton = ({ color, ...props }) => {
  return (
    <IconButton
      paddingH={0.8}
      color={color || 'dark2'}
      bold
      iconSize={1}
      borderColor={color || 'light3'}
      borderWidth={0.15}
      {...props}
    />
  )
}

export default _IconButton
